import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { getPayloadConfigFromPayload, useChartContext } from "./context";
import { useChartTooltipContext } from "./ChartTooltipContext";

export interface ChartTooltipLabelProps {
  /** Formats the resolved label — e.g. locale date formatting for time-series charts. */
  format?: (value: ReactNode) => ReactNode;
  className?: string;
}

/** The tooltip's header: the hovered category/axis label, resolved through the Chart config. */
export const ChartTooltipLabel = ({ format, className }: ChartTooltipLabelProps) => {
  const { config } = useChartContext();
  const { payload, label } = useChartTooltipContext();

  const [item] = payload;
  const key = `${item?.dataKey ?? item?.name ?? "value"}`;
  const itemConfig = getPayloadConfigFromPayload(config, item, key);
  const value = typeof label === "string" ? config[label]?.label ?? label : itemConfig?.label;

  if (!format && !value) return null;

  return (
    <div data-slot="chart-tooltip-label" className={cn("font-medium", className)}>
      {format ? format(value) : value}
    </div>
  );
};
